import { render, staticRenderFns } from "./ParentChildPieChart.vue?vue&type=template&id=21e0cadb&scoped=true"
import script from "./ParentChildPieChart.vue?vue&type=script&lang=js"
export * from "./ParentChildPieChart.vue?vue&type=script&lang=js"
import style0 from "./ParentChildPieChart.vue?vue&type=style&index=0&id=21e0cadb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e0cadb",
  null
  
)

export default component.exports